import { MobilityQuestionnaire } from "src/app/core/models/mobility-questionnaire";

export class QuestionnaireAnswerExtractor {
  static extractAnswersMap(questionnaire: MobilityQuestionnaire): {
    [sectionIndex: number]: { [questionIndex: number]: string };
  } {
    const sectionAnswersMap: {
      [sectionIndex: number]: { [questionIndex: number]: string };
    } = {};

    questionnaire.sections.forEach((section, sectionIdx) => {
      const sectionAnswers: { [questionIndex: number]: string } = {};
      section.questions?.forEach((question, questionIdx) => {
        if (question.answer) {
          sectionAnswers[questionIdx] = question.answer;
        }
      });
      sectionAnswersMap[sectionIdx] = sectionAnswers;
    });

    return sectionAnswersMap;
  }

  static getExpirationDate(questionnaire: MobilityQuestionnaire): Date {
    if (!questionnaire?.createdAt) {
      return new Date();
    }

    const createdDate = new Date(questionnaire.createdAt);
    const expirationDate = new Date(createdDate);
    expirationDate.setMonth(expirationDate.getMonth() + 12);
    return expirationDate;
  }
}
